import { actions } from "./action.js";
function routeGuardCrumbsListFactory({ childrenPath, blacklist }) {
  return (to, from, next) => {
    if (!to.path.includes(childrenPath)) {
      next();
      return;
    }
    let crumbsList = JSON.parse(localStorage.getItem("crumbsList") || "[]");
    const newTo = {
      path: to.path,
      fullPath: to.fullPath,
      meta: to.meta,
      name: to.name,
      query: to.query,
      params: to.params
    };
    if (to.name && blacklist.includes(to.name) || to.query.isBlackRouter) {
      next();
      return;
    }
    const isExistence = (crumbsList || []).reduce((ele, item) => {
      if (item.path === newTo.path) {
        ele = true;
      }
      return ele;
    }, false);
    if (isExistence) {
      next();
      return;
    }
    crumbsList.push(newTo);
    if (crumbsList.length > 8) {
      crumbsList = crumbsList.slice(1);
    }
    localStorage.setItem("crumbsList", JSON.stringify(crumbsList));
    actions.setGlobalState({ crumbsList });
    next();
  };
}
export { routeGuardCrumbsListFactory };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/qiankun/routeGuardCrumbsListFactory.js